import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationPayIn3 = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationPayIn3',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_28405_76264)",
    fillRule: "evenodd",
    d: "M2.94 43.99H72.7V27.06c0-2.21-1.79-4-4-4H12.94c-5.52 0-10 4.48-10 10v10.93Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_28405_76264)",
    fillRule: "evenodd",
    d: "M48.01 3.52c2.66-2.7 7.03-2.72 9.84-.08l.14.13 22.76 22.46c2.76 2.73 2.89 7.09.32 9.84l-.13.13L44.1 73.36c-2.66 2.7-7.03 2.72-9.84.08l-.14-.13-22.76-22.46c-2.76-2.73-2.89-7.09-.32-9.84l.13-.13L48.01 3.52Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint2_linear_28405_76264)",
    fillRule: "evenodd",
    d: "M30.85 41.19h-17.5c-5.74 0-10.4-2.42-10.4-8.16v49.39c0 5.74 4.66 10.4 10.4 10.4H79.6c2.2 0 3.99-1.78 3.99-3.99V45.18c0-2.2-1.78-3.99-3.99-3.99H30.85Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint3_linear_28405_76264)",
    d: "M96.752 77.57a24.85 24.85 0 1 0-49.085-7.8 24.85 24.85 0 0 0 49.085 7.8Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#fff",
    d: "M70.4 89.782c.006 1.105-.887 2.018-1.984 1.893a16.722 16.722 0 0 1-13.658-22.77c.407-1.027 1.633-1.385 2.604-.859l11.906 6.45a2 2 0 0 1 1.047 1.746l.084 13.54ZM59.414 64.436c-.96-.547-1.305-1.777-.648-2.665a16.722 16.722 0 0 1 26.548-.442c.687.865.383 2.106-.558 2.684L73.218 71.1a2 2 0 0 1-2.036.034l-11.768-6.697Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_28405_76264",
    x1: -3.711,
    x2: 69.377,
    y1: 33.347,
    y2: 33.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.123,
    stopColor: "#2A44C6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.595,
    stopColor: "#4A68FB"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_28405_76264",
    x1: -3.979,
    x2: 91.234,
    y1: 91.957,
    y2: -9.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.461,
    stopColor: "#4BC7FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#DEFBA9"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear_28405_76264",
    x1: 88.738,
    x2: 7.64,
    y1: 26.922,
    y2: 89.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#C1D0C9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.516,
    stopColor: "#5E97F7"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#4B8AFF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear_28405_76264",
    x1: 39.892,
    x2: 85.132,
    y1: 109.23,
    y2: 59.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#7083FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.16,
    stopColor: "#6C8DFE"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.44,
    stopColor: "#62A7FC"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.73,
    stopColor: "#54CAFA"
  }))));
};
ColoredIllustrationPayIn3.displayName = 'ColoredIllustrationPayIn3';
export default withProvisionalOverrideFromContext(ColoredIllustrationPayIn3);
//# sourceMappingURL=index.js.map